<template>
  <div class="basic">
    <Form
      ref="formInline"
      :model="formInline"
      style="width: 100%"
      :rules="ruleInline"
      label-position="top"
      @on-validate="getvalidate"
    >
      <div class="basic-header">
        <p>- 企业基本信息 Company Information -</p>
      </div>
      <div style="border: solid 1px #e5e5e5; margin-bottom: 30px">
        <!-- 公司名称 -->
        <div class="basic-name">
          <Row :gutter="10">
            <Col span="24">
              <div style="display: flex">
                <FormItem label="公司名称（中文） Company Name" prop="companyName">
                  <Input
                    type="text"
                    v-model="formInline.companyName"
                    style="width: 500px; margin-right: 10px"
                    placeholder="请输入企业名称（必须和营业执照一致） Please enter Company Name"
                  />
                </FormItem>
                <FormItem label="公司简称（2~5个字）Company Name for short" prop="companyNameShort">
                  <Input
                    type="text"
                    placeholder="请输入公司简称 Please enter Company Name for short"
                    v-model="formInline.companyNameShort"
                    style="width: 500px; margin-right: 10px"
                  />
                </FormItem>
              </div>
            </Col>
            <Col span="24">
              <div style="display: flex">
                <FormItem label="统一社会信用代码" prop="creditCode" id="creditCode" v-if="isShowFormEl">
                  <Input
                    type="text"
                    placeholder="请输入统一社会信用代码 If not, please fill in 'no'"
                    v-model="formInline.creditCode"
                    style="width: 500px"
                  />
                </FormItem>
              </div>
            </Col>
            <Col span="24">
              <div style="display: flex">
                <FormItem label="英文名称 Company English Name" prop="companyNameEn">
                  <Input
                    type="text"
                    placeholder="请输入英文名称 Please enter Company English Name"
                    v-model="formInline.companyNameEn"
                    style="width: 500px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="英文简称 Company Name for short" prop="companyNameShortEn">
                  <Input
                    type="text"
                    placeholder="请输入英文简称 Please enter Company Name for short"
                    v-model="formInline.companyNameShortEn"
                    style="width: 500px; margin-right: 10px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
          <!-- <Row>
            <Col :span="12">
            </Col>
            <Col :span="12">
            </Col>
          </Row> -->
        </div>
        <!-- 公司地址 -->
        <div class="basic-name">
          <Row :gutter="10">
            <Col span="13">
              <FormItem label="公司地址 Company Address" required prop="addresss">
                <div style="width: 550px">
                  <mFormAddress
                    v-model="formInline.addresss"
                    @change="validAddresss"
                  ></mFormAddress>
                </div>
              </FormItem>
            </Col>

            <Col span="9">
              <div style="padding: 0 0 3px 0"></div>
              <div style="display: flex">
                <FormItem prop="address" id="address" label="详细地址 Company Address">
                  <Input
                    type="text"
                    placeholder="请输入详细地址 Please enter Company Address"
                    v-model="formInline.address"
                    style="width: 340px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem prop="postcode" id="postcode" label="邮编 Postcode">
                  <Input
                    type="text"
                    placeholder="请输入邮编 Postcode"
                    v-model="formInline.postcode"
                    style="width: 160px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
        </div>
        <div class="basic-name" v-if="isShowFormEl">
          <Row :gutter="10">
            <Col span="16">
              <FormItem label="营业执照上传（小于5M）/Company registration certificate" required>
                <div style="display: flex; position: relative">
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg', 'png', 'pdf']"
                    :max-size="5120"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    :action="uploadUrl"
                    style="margin-right: 10px"
                  >
                    <div class="upload-btn">上传营业执照/Company registration certificate</div>
                  </Upload>
                  <p
                    style="
                      position: absolute;
                      left: 0;
                      top: 34px;
                      font-size: 12px;
                      color: #808080;
                    "
                  >
                    上传文件接受JPG、PNG、PDF格式，文件大小不得超过5M。没有营业执照，主办方不予分配展位/jpg,png,pdf only, within 5M
                  </p>
                  <div class="license-img">
                    <template v-if="uploadList && uploadList.length">
                      <div
                        class="license-img-list"
                        v-for="(item, index) in uploadList"
                        :key="'upload' + index"
                      >
                        <template v-if="item.status === 'finished'">
                          <span class="txt1" :title="item.name" v-if="item.name">{{
                            item.name.split(".")[0]
                          }}</span>
                          <span class="line"></span>
                          <span @click="handleRemoveByArr(item)">删除</span>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>

      <!-- 展会联系人 -->
      <div class="basic-link">
        <FormItem label="展会联系人 Contact Person" required> </FormItem>
      </div>
      <div style="border: solid 1px #e5e5e5; margin-bottom: 30px">
        <div class="basic-links">
          <Row :gutter="10">
            <Col span="12">
              <div style="display: flex">
                <FormItem label="姓名 Name" prop="linkMan">
                  <Input
                    type="text"
                    placeholder="请输入姓名 Name"
                    v-model="formInline.linkMan"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="职务 Position" prop="linkTitle">
                  <Input
                    type="text"
                    placeholder="请输入职务 Please enter Position"
                    v-model="formInline.linkTitle"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
            <Col span="12">
              <div style="display: flex">
                <FormItem label="手机 Mobilephone" prop="linkMob">
                  <Input
                    placeholder="请输入手机号 Please enter Mobilephone"
                    v-model="formInline.linkMob"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="邮箱 E-mail" prop="linkEmail">
                  <Input
                    type="text"
                    placeholder="请输入邮箱 Please enter E-mail"
                    v-model="formInline.linkEmail"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row :gutter="10">
            <Col span="12">
              <Row>
                <Col span="12">
                  <FormItem label="座机电话 Tel" :required="false">
                    <div style="display: flex">
                      <FormItem prop="linkCode">
                        <Input
                          v-model="formInline.linkCode"
                          style="width: 90px; margin-right: 10px"
                          placeholder="请输入区号"
                        />
                      </FormItem>
                      一 &nbsp
                      <FormItem prop="linkTelephone">
                        <Input
                          v-model="formInline.linkTelephone"
                          style="width: 140px; margin-right: 10px"
                          placeholder="电话号码"
                        />
                      </FormItem>
                    </div>
                    <p
                      style="
                        line-height: 1;
                        font-size: 12px;
                        color: #808080;
                        position: relative;
                        top: -12px;
                      "
                    >
                      示例：010-6343 0880
                    </p>
                    <p
                      style="
                        line-height: 1.2;
                        font-size: 12px;
                        color: #808080;
                        position: relative;
                        top: -12px;
                      "
                    >
                      If not, please fill in 'no'
                    </p>
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem
                    label="QQ"
                    prop="linkQQ"
                    style="position: relative; margin-left: -10px"
                  >
                    <Input
                      placeholder="展会联系人QQ"
                      v-model="formInline.linkQQ"
                      style="width: 270px"
                    />
                  </FormItem>
                </Col>
              </Row>
            </Col>
            <Col span="12">
              <FormItem label="微信 WeChat" prop="linkWeChat">
                <Input
                  type="text"
                  placeholder="请输入微信 Please enter WeChat"
                  v-model="formInline.linkWeChat"
                  style="width: 270px"
                />
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>

      <!-- 开票信息 -->
      <div class="basic-invoiceType">
        <p style="padding-left: 11px; font-size: 18px">开票信息 Invoice</p>
        <Checkbox v-model="isInvoice"><span>无开票信息 No Invoice</span></Checkbox>
      </div>
      <div style="border: solid 1px #e5e5e5; margin-bottom: 30px">
        <div class="basic-invoices" v-if="!isInvoice">
          <Row :gutter="10">
            <Col span="12">
              <div style="display: flex">
                <FormItem label="发票抬头" prop="invoiceTitle">
                  <Input
                    type="text"
                    placeholder="请输入发票抬头 If not, please fill in 'no'"
                    v-model="formInline.invoiceTitle"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="税号" prop="invoiceCode">
                  <Input
                    type="text"
                    placeholder="请输入税号 If not, please fill in 'no'"
                    v-model="formInline.invoiceCode"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
             <Col span="12">
              <div style="display: flex">
                <FormItem label="发票类型" prop="invoiceType">
                  <RadioGroup v-model="formInline.invoiceType">
                    <Radio label="增值税专票">
                      <span>增值税专用发票</span>
                    </Radio>
                    <Radio label="增值税普票">
                      <span>增值税普通发票</span>
                    </Radio>
                  </RadioGroup>
                </FormItem>
              </div>
            </Col>
            <Col v-if="false" span="12">
              <div style="display: flex">
                <FormItem label="单位地址" prop="invoiceAddress">
                  <Input
                    type="text"
                    placeholder="请输入单位地址 If not, please fill in 'no'"
                    v-model="formInline.invoiceAddress"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="电话号码" prop="invoiceTelephone">
                  <Input
                    type="text"
                    placeholder="请输入电话号码 If not, please fill in 'no'"
                    v-model="formInline.invoiceTelephone"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row :gutter="10">
            <Col v-if="false" span="12">
              <div style="display: flex">
                <FormItem label="开户银行" prop="invoiceBank">
                  <Input
                    type="text"
                    v-model="formInline.invoiceBank"
                    placeholder="请输入开户银行 If not, please fill in 'no'"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="银行账户" prop="invoiceBankAccount">
                  <Input
                    type="text"
                    v-model="formInline.invoiceBankAccount"
                    placeholder="请输入银行账户 If not, please fill in 'no'"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
            <Col v-if="false" span="12">
              <div style="display: flex">
                <FormItem label="发票类型" prop="invoiceType">
                  <RadioGroup v-model="formInline.invoiceType">
                    <Radio label="增值税专票">
                      <span>增值税专用发票</span>
                    </Radio>
                    <Radio label="增值税普票">
                      <span>增值税普通发票</span>
                    </Radio>
                  </RadioGroup>
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row v-if="false" :gutter="10">
            <Col span="12">
              <FormItem label="发票邮寄地址" required prop="invoiceMalingAdresss">
                <div style="width: 550px">
                  <mFormAddress
                    v-model="formInline.invoiceMalingAdresss"
                    @change="MalingAdresssAddresss"
                  ></mFormAddress>
                </div>
              </FormItem>
            </Col>

            <Col span="10">
              <div style="padding: 0 0 3px 0"></div>
              <div style="display: flex">
                <FormItem prop="invoiceMalingAdress" label="详细地址">
                  <Input
                    type="text"
                    placeholder="请输入详细地址"
                    v-model="formInline.invoiceMalingAdress"
                    style="width: 410px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem prop="invoiceMalingCode" label="邮编">
                  <Input
                    type="text"
                    placeholder="请输入邮编"
                    v-model="formInline.invoiceMalingCode"
                    style="width: 130px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row :gutter="10">
            <Col span="12">
              <div style="display: flex">
                <FormItem label="发票收件人 E-mail" prop="invoiceRecivePerson">
                  <Input
                    type="text"
                    placeholder="请输入发票收件人 E-mail"
                    v-model="formInline.invoiceRecivePerson"
                    style="width: 270px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem label="收件人电话 mobilephone" prop="invoiceReciveTel">
                  <Input
                    type="number"
                    placeholder="请输入收件人电话 mobilephone"
                    v-model="formInline.invoiceReciveTel"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <!-- <div class="handle-box">
        <Button :loading="loading" @click="handleSubmit('formInline')" class="handle-box-btn" type="primary">保存并提交</Button>
      </div> -->
    </Form>
  </div>
</template>

<script>
import mFormAddress from "@components/m-form/m-form-address-cn-en.vue";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
export default {
  name: "register-form", // 参展申请 - 基本信息
  components: {
    mFormAddress,
  },
  data() {
    const that = this;
    const companyAddressValid = (rule, value, callback) => {
      if (
        that.formInline.addresss.country &&
        that.formInline.addresss.country === "中国"
      ) {
        // 中国 判断省份和城市是否选择
        if (!that.formInline.addresss.province) {
          callback(new Error("省份为空 Province"));
        } else if (!that.formInline.addresss.city) {
          callback(new Error("城市为空 City"));
        } else {
          callback();
        }
      } else {
        if (that.formInline.addresss.country) {
          callback();
        } else {
          callback(new Error("地址为空 Company Address"));
        }
      }
    };

    // 判断中文
    // const zhValid = (rule, value, callback) => {
    //   if (/^[\u4e00-\u9fa5]+$/.test(value)) {
    //     callback();
    //   } else {
    //     callback(new Error("公司名称格式有误"));
    //   }
    // };
    // 判断英文
    const enValid = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        if (/^(?!\s*$)[A-Za-z0-9.,_\-\&\(\)\（）\s-]+$/.test(value)) {
          callback();
        } else {
          callback(new Error("英文名称格式有误"));
        }
      }
    };

    const validEmail = (rule, value, callback) => {
      if (value) {
        if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
          callback();
        } else {
          callback("请输入正确的邮箱地址");
        }
      } else {
        callback();
      }
    };

    const invoiceAddressValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (
          that.formInline.invoiceMalingAdresss.country &&
          that.formInline.invoiceMalingAdresss.country === "中国"
        ) {
          // 中国 判断省份和城市是否选择
          if (!that.formInline.invoiceMalingAdresss.province) {
            callback(new Error("省份为空"));
          } else if (!that.formInline.invoiceMalingAdresss.city) {
            callback(new Error("城市为空"));
          } else {
            callback();
          }
        } else {
          if (that.formInline.invoiceMalingAdresss.country) {
            callback();
          } else {
            callback(new Error("地址为空"));
          }
        }
      }
    };
    const invoiceTitleValid = (rule, value, callback) => {
      if (value == 'no') return true;
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入发票抬头 If not, please fill in 'no'"));
        } else {
          callback();
        }
      }
    };
    const invoiceCodeValid = (rule, value, callback) => {
      if (value == 'no') return true;
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (value) {
          if (/^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(value) || value == 'no') {
            callback();
          } else {
            callback("发票税号格式有误 If not, please fill in 'no'");
          }
        } else {
          callback(new Error("请输入发票税号 If not, please fill in 'no'"));
        }
      }
    };
    const invoiceAddValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入单位地址"));
        } else {
          callback();
        }
      }
    };
    const invoiceTelephoneValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入单位电话号码"));
        } else {
          callback();
        }
      }
    };
    const invoiceBankValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入开户银行"));
        } else {
          callback();
        }
      }
    };
    const invoiceBankAccountValid = (rule, value, callback) => {
      if (value == 'no') return true;
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (that.formInline.invoiceType === "增值税专票") {
          if (!value) {
            callback(new Error("请输入银行账号"));
          } else {
            // if (/^[0-9]{14,20}$/.test(value)) {
            if (/^[0-9]{0,50}$/.test(value)) {
              callback();
            } else {
              callback(new Error("银行账号格式有误"));
            }
          }
        } else {
          if (!value) {
            callback();
          } else {
            if (/^[0-9]{0,50}$/.test(value)) {
              callback();
            } else {
              callback(new Error("银行账号格式有误"));
            }
          }
        }
      }
    };
    const invoiceTypeValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入发票类型"));
        } else {
          callback();
        }
      }
    };
    const invoiceMalingAdressValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入详细地址"));
        } else {
          callback();
        }
      }
    };
    const invoiceRecivePersonValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入发票收件人 E-mail"));
        } else {
          callback();
        }
      }
    };
    const invoiceReciveTelValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入收件人电话 mobilephone"));
        } else {
          callback();
        }
      }
    };
    return {
      // 定义需要过滤的特殊符号和关键词
      forbiddenTokens: [
        // 特殊符号
        "'",
        '"',
        "`",
        "(",
        ")",
        "[",
        "]",
        "{",
        "}",
        ";",
        ",",
        "=",
        "#",
       
        "/*",
        "*/",
        "&",
        "|",
        "^",
        "*",
        "+",
       
        "%",
      

        // 关键词
        "select",
        "insert",
        "delete",
        "update",
        "count",
        "union",
        "join",
        "where",
        "create",
        "alter",
        "drop",
        "truncate",
        "exec",
        "xp_cmdshell",
        "master",
        "char",
        "declare",
        "or",
      ],

      loading: false,
      isInvoice: false,
      formInline: {
        // 企业基本信息
        companyName: "", // 公司名称
        companyNameShort: "", // 公司简称
        companyNameEn: "", // 公司英文名称
        companyNameShortEn: "", // 公司英文简称
        creditCode: "", // 统一社会信用代码
        address: "", // 详细地址
        addresss: {
          country: "", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县
        },
        postcode: "",

        // 展会联系人
        linkMan: "",
        linkTitle: "",
        linkTelephone: "",
        linkEmail: "",
        linkCode: "", // 区号
        linkMob: "", // 电话号码
        linkQQ: "",
        linkWeChat: "",
        // 开票信息
        invoiceTitle: "",
        invoiceCode: "",
        invoiceAddress: "",
        invoiceTelephone: "",
        invoiceBank: "",
        invoiceBankAccount: "",
        invoiceType: "增值税专票",

        invoiceMalingAdresss: {
            country: "",
            province: "",
            city: "",
            county: "",
        },

        invoiceMalingAdress: "",
        invoiceMalingCode: "",
        invoiceRecivePerson: "",
        invoiceReciveTel: "",
      },
      formInline2: {
        // 企业基本信息
        companyName: "上海连战技术有限公司", // 公司名称
        companyNameShort: "连战", // 公司简称
        companyNameEn: "lianzhan", // 公司英文名称
        companyNameShortEn: "lianzhan", // 公司英文名称
        creditCode: "91310118MA1JM12CX7", // 统一社会信用代码
        address: "金沙江西路1555路慧创国际16号2层", // 详细地址
        addresss: {
          country: "中国", // 国家
          province: "上海", // 省份
          city: "嘉定", // 城市
          county: "", // 区县
        },
        postcode: "201803",

        // 展会联系人
        linkMan: "李某",
        linkTitle: "技术",
        linkMob: "13122959676",
        linkEmail: "2624006658@qq.com",
        linkCode: "021", // 区号
        linkTelephone: "8888888", // 电话号码
        linkQQ: "2624006658",
        linkWeChat: "xiansheng",
      },
      ruleInline: {
        // 企业基本信息
        companyName: [
          { required: true, message: "请输入公司名称 Please enter Company Name", trigger: "blur" },
          // { validator: zhValid, trigger: "blur" }
        ],
        companyNameShort: [
          { required: true, message: "请输入公司简称 Please enter Company Name for short", trigger: "blur" },
          {
            type: "string",
            min: 2,
            max: 5,
            message: "公司简称长度在2到5个字符",
            trigger: "blur",
          },
        ],
        companyNameEn: [{ validator: enValid, trigger: "blur" }],
        creditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空 If not, please fill in 'no'",
            trigger: "blur",
          },
          ...validator.CreditCode,
        ],
        addresss: [
          {
            required: true,
            validator: companyAddressValid,
            trigger: "blur",
          },
        ],
        address: [{ required: true, message: "请输入详细地址 Company Address", trigger: "blur" }],

        // 展会联系人
        linkMan: [{ required: true, message: "请输入姓名 Name", trigger: "blur" }],
        linkTitle: [{ required: true, message: "请输入职务 Please enter Position", trigger: "blur" }],
        linkMob: [
          {
            required: true,
            message: "请输入手机号 Please enter Mobilephone",
            trigger: "blur",
          },
          ...validator.phone,
        ],
        linkEmail: [
          { required: true, message: "邮箱不能为空 Please enter E-mail", trigger: "blur" },
          { validator: validEmail, trigger: "blur" },
        ],
        // 开票信息
        invoiceTitle: [
            { required: true, validator: invoiceTitleValid, trigger: "blur" }
        ],

        invoiceCode: [
            { required: true, validator: invoiceCodeValid, trigger: "blur" }
        ],

        invoiceAddress: [
            { required: true, validator: invoiceAddValid, trigger: "blur" }
        ],

        invoiceTelephone: [
            { required: true, validator: invoiceTelephoneValid, trigger: "blur" }
        ],

        invoiceBank: [
            { required: true, validator: invoiceBankValid, trigger: "blur" }
        ],

        invoiceBankAccount: [
            { required: true, validator: invoiceBankAccountValid, trigger: "blur" }
        ],

        invoiceType: [
            { required: true, validator: invoiceTypeValid, trigger: "blur" }
        ],

        invoiceMalingAdresss: [
            {
                required: true,
                validator: invoiceAddressValid,
                trigger: "blur",
            },
        ],

        invoiceMalingAdress: [
            {
                required: true,
                validator: invoiceMalingAdressValid,
                trigger: "blur",
            },
        ],

        invoiceRecivePerson: [
            {
                required: true,
                validator: invoiceRecivePersonValid,
                trigger: "blur",
            },
        ],

        // invoiceReciveTel: [
        //     {
        //         required: true,
        //         validator: invoiceReciveTelValid,
        //         trigger: "blur",
        //     },
        // ],
      },
      defaultList: [],
      uploadList: [],
      uploadName: "",

      basicInfo: null,
      validateList: [],
      ElepropName: "", //验证错误的prop名
      companyId: "", //公司ID
      isOption: true, //企业经营类型是否是选择框

      countryList: [],
      provinceArr: [],
      citiesArr: [],
      isShowFormEl: true,
    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      exhibitionId: "getExhibitionId",
      company: "getCompany",
    }),
    userId() {
      return this.$route.query.userId;
    },
  },
  watch: {
    "formInline.addresss.country": function (newValue) {
        if (newValue == "中国") {
            this.isShowFormEl = true;
        } else {
            this.isShowFormEl = false;
        }
    },

    "formInline.addresss.province": function (newValue) {
        if (
            newValue == "香港" ||
            newValue == "澳门" ||
            newValue == "台湾" ||
            newValue == ""
        ) {
            this.isShowFormEl = false;
        } else {
            this.isShowFormEl = true;
        }
    },
  },
  mounted() {
    this.isShowFormEl = true;
  },
  methods: {
    ...mapActions({
      getCityByParentId: "exhibitionModule/getCityByParentId",
      addApplyCompany: "addApplyCompany",
      editApplyCompany: "editApplyCompany",
    }),

    MalingAdresssAddresss() {
        this.$refs["formInline"].validateField(
            "invoiceMalingAdresss",
            () => {}
        );
    },

    getvalidate(prop, status, error) {
      if (status == false) {
        let opt = {
          prop: prop,
          status: status,
          error: error,
        };
        this.validateList.push(opt);
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, ) => {
        this.$refs[name].validate((valid) => {
        //   console.log(valid, "valid");
          resolve(valid);
        });
      });
    },

    /**
     * 过滤输入内容
     * @param {string} field - 表单字段名
     */
    filterInput(inputValue, fieldName) {
      // 将输入值统一转换为小写
      const lowerInputValue = String(inputValue || "").toLowerCase();

      // 检查输入内容是否包含特殊符号或关键词（不区分大小写）
      const invalidTokens = this.forbiddenTokens.filter((token) =>
        lowerInputValue.includes(token.toLowerCase())
      );

      if (invalidTokens.length > 0) {
        return {
          isValid: false,
          message: `${invalidTokens.join(", ")}`,
          field: fieldName,
        };
      }
      return { isValid: true };
    },

    async handleSubmit() {
      let form = this.formInline;
      const fields = [
        {
          name: "companyName",
          text: "公司名称（中文）",
          value: this.formInline.companyName,
        },
        {
          name: "companyNameShort",
          text: "公司简称（2~5个字）",
          value: this.formInline.companyNameShort,
        },
        {
          name: "creditCode",
          text: "统一社会信用代码",
          value: this.formInline.creditCode,
        },
        { name: "companyNameEn", text: "英文名称", value: this.formInline.companyNameEn },
        {
          name: "companyNameShortEn",
          text: "英文简称",
          value: this.formInline.companyNameShortEn,
        },
        { name: "address", text: "详细地址", value: this.formInline.address },
        { name: "postcode", text: "邮编", value: this.formInline.postcode },
        { name: "linkMan", text: "姓名", value: this.formInline.linkMan },
        { name: "linkTitle", text: "职务", value: this.formInline.linkTitle },
        { name: "linkMob", text: "手机", value: this.formInline.linkMob },
        // { name: "linkEmail", text: "邮箱", value: this.formInline.linkEmail },
        { name: "linkCode", text: "座机电话(区号)", value: this.formInline.linkCode },
        {
          name: "linkTelephone",
          text: "座机电话(电话号码)",
          value: this.formInline.linkTelephone,
        },
        { name: "linkQQ", text: "QQ", value: this.formInline.linkQQ },
        { name: "linkWeChat", text: "微信", value: this.formInline.linkWeChat },
      ];

      if (!this.isInvoice) {
        fields.push(
          { name: "invoiceTitle", text: "发票抬头", value: form.invoiceTitle },
          { name: "invoiceCode", text: "税号", value: form.invoiceCode },
          { name: "invoiceAddress", text: "单位地址", value: form.invoiceAddress },
          { name: "invoiceTelephone", text: "电话号码", value: form.invoiceTelephone },
          { name: "invoiceBank", text: "开户银行", value: form.invoiceBank },
          { name: "invoiceBankAccount", text: "银行账户", value: form.invoiceBankAccount },
          { name: "invoiceMalingAdress", text: "发票邮寄地址", value: form.invoiceMalingAdress },
          { name: "invoiceRecivePerson", text: "发票收件人", value: form.invoiceRecivePerson },
          { name: "invoiceReciveTel", text: "收件人电话", value: form.invoiceReciveTel }
        );
      }

      for (const field of fields) {
        const result = this.filterInput(field.value, field.name);
        if (!result.isValid) {
          this.$Message.error(
            `${field.text} 输入内容包含特殊字符或关键词：${result.message}`
          );
          return; // 停止提交
        }
      }
      let imgBusinessLicense = "";
      let valid = await this.validForm("formInline");
      let errTxt = "";
      if (!valid) {
        errTxt = this.validateList[0] ? this.validateList[0].error : "请完善表单";
      }
      if (this.isShowFormEl) {
          if (this.uploadList && this.uploadList.length) {
              imgBusinessLicense = this.uploadList[0];
          } else {
              errTxt = "请上传营业执照/Please upload Company registration certificate";
              valid = false;
          }
      }
      if (errTxt) {
        this.$Message.error(errTxt);
        this.validateList = [];
      }
      let formValue = {
        companyName: form.companyName, // 公司名称
        companyNameShort: form.companyNameShort, // 公司简称
        companyNameEn: form.companyNameEn, // 公司英文名称
        companyNameShortEn: form.companyNameShortEn, // 公司英文名称
        unifiedCode: form.creditCode, // 统一社会信用代码
        address: form.address, // 详细地址
        country: form.addresss.country,
        province: form.addresss.province,
        city: form.addresss.city,

        postcode: form.postcode,

        // 展会联系人
        linkMan: form.linkMan,
        linkTitle: form.linkTitle,
        linkTelephone: form.linkTelephone,
        linkEmail: form.linkEmail,
        linkCode: form.linkCode, // 区号
        linkMob: form.linkMob, // 电话号码
        linkQQ: form.linkQQ,
        linkWeChat: form.linkWeChat,

        // 开票信息
        invoiceTitle: form.invoiceTitle,
        invoiceCode: form.invoiceCode,
        invoiceAddress: form.invoiceAddress,
        invoiceTelephone: form.invoiceTelephone,
        invoiceBank: form.invoiceBank,
        invoiceBankAccount: form.invoiceBankAccount,
        invoiceType: form.invoiceType,

        invoiceMalingCountry: form.invoiceMalingAdresss.country,
        invoiceMalingProvince: form.invoiceMalingAdresss.province,
        invoiceMalingCity: form.invoiceMalingAdresss.city,

        invoiceMalingAdress: form.invoiceMalingAdress,
        invoiceMalingCode: form.invoiceMalingCode,
        invoiceRecivePerson: form.invoiceRecivePerson,
        invoiceReciveTel: form.invoiceReciveTel,

        imgBusinessLicense: JSON.stringify(imgBusinessLicense),
      };
      return new Promise((resolve,) => {
        resolve({ valid: valid, form: formValue });
      });
    },
    validAddresss() {
      // this.$refs['formInline'].validateField('addresss', (valid) => {
      //   console.log("addresss", valid);
      // });
    },

    handleSuccess(res, file) {
      if (res && res.list.length) {
          file.url = res.list[0];

          this.uploadList.push({
              name: this.uploadName,
              url: res.list[0],
              status: "finished",
          });
      } else {
          this.uploadName = "";
      }
  },

    handleFormatError() {
        this.uploadName = "";

        this.$Notice.warning({
            title: "文件格式是不正确的/The File Format Is Invalid",
            desc: "请上传jpg或者png格式的图片或者pdf格式的文件",
        });
    },

    handleMaxSize() {
        this.uploadName = "";

        this.$Notice.warning({
            title: "文件大小超过限制/File size exceeds limit",
            desc: "Please upload images smaller than 5M",
        });
    },

    handleBeforeUpload(e) {
        this.uploadName = e.name;

        const limitNum = 1;

        const check = this.uploadList.length < limitNum;

        if (!check) {
            this.$Notice.warning({
                title: `最多上传${limitNum}张图片`,
            });
        }

        return check;
    },

    handleRemoveByArr(file) {
        const fileList = this.uploadList;

        this.uploadList.splice(fileList.indexOf(file), 1);
    },
  },
};
</script>

<style scoped lang="scss">
.basic {
  /deep/ {
    .ivu-checkbox-checked .ivu-checkbox-inner {
      border-color: #4f65ae;
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }

    .ivu-upload-select {
      display: flex;
    }

    .ivu-radio-checked .ivu-radio-inner {
      border-color: #4f65ae !important;
    }

    .ivu-radio-inner:after {
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }

    .ivu-switch-checked {
      border-color: #4f65ae;
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
      linear-gradient(#b10042, #b10042);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;

    .ivu-checkbox-wrapper {
      margin: 0;
    }

    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }
}

.upload-btn {
    padding: 0 10px;
    height: 32px;
    text-align: center;
    cursor: pointer;
    background-color: #f5f5f5;
    border: solid 1px #bfbfbf;
}

.license-img {
    display: flex;
    flex-wrap: wrap;

    &-list {
        line-height: 32px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        margin-right: 10px;
        margin-bottom: 10px;
        background-color: #f5f5f5;

        .txt1 {
            width: 200px;
            display: inline-block;
            height: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #515a6e !important;
        }

        span {
            color: #d00300;
            cursor: pointer;
        }

        .line {
            width: 1px;
            height: 24px;
            background-color: #e6e6e6;
            margin: 0 6px;
        }
    }
}
</style>
